import EventBus from '@/eventBus'

const actions = {
  handleUpdatePresentationToSocketAction({ dispatch, rootState }) {
    const rootSlides = rootState.presentation.slides

    EventBus.$emit('getDataPresentationDetail')
    dispatch('setSlideActive', rootSlides[0], { root: true })
  },
}
export default {
  namespaced: true,
  actions,
}
